import { render } from "./ThreeDSceneEditorCmp.vue?vue&type=template&id=10b780f0&scoped=true"
import script from "./ThreeDSceneEditorCmp.vue?vue&type=script&lang=js"
export * from "./ThreeDSceneEditorCmp.vue?vue&type=script&lang=js"

import "./ThreeDSceneEditorCmp.vue?vue&type=style&index=0&id=10b780f0&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b780f0"]])

export default __exports__